import { CUSTOM_SESSION_ID_KEY, SESSION_ID_KEY } from '../config/constants';
import { getISOTime } from '../getters/get-time-stamp';
import { getCookie } from '../helpers/cookie';
import { emit } from '../helpers/event-bus';
export const firstLaunch = {
  eventAction: 'first_launch'
};
export const startSession = {
  eventAction: 'start_session'
};
export const scheduleFirstLaunchEvent = deviceId => {
  firstLaunch.deviceId = deviceId;
  startSession.deviceId = deviceId;
  firstLaunch.timeStamp = getISOTime();

  // firstLaunch на работающую сессию (если меняемся между _sa и _sv)
  const sessionId = getCookie(CUSTOM_SESSION_ID_KEY) || getCookie(SESSION_ID_KEY);
  if (sessionId) {
    firstLaunch.sessionId = sessionId;
    emit(firstLaunch);
  }
};
export const scheduleStartSessionEvent = sessionId => {
  firstLaunch.sessionId = sessionId;
  startSession.sessionId = sessionId;
  startSession.timeStamp = getISOTime();
  emit(firstLaunch);
  emit(startSession);
};